import React, { memo, type ReactElement } from 'react';
import { SkeletonLoader } from '@saviynt/design-system';

import './AagTimelineLoader.css';

export interface AuditLogTimelineLoaderProps {
  count: number;
}

function AuditLogTimelineLoaderComponent({
  count = 5,
}: AuditLogTimelineLoaderProps): ReactElement {
  const rows = Array.from({ length: count }, (_, i) => i);

  return (
    <div className='Aag-TimelineLoader'>
      {rows.map((idx, lastIndex) => (
        <div key={idx} className='Aag-TimelineLoader-row'>
          {/* Actions column placeholder */}
          <div className='Aag-TimelineLoader-actions'>
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='1.5rem'
              width='1.5rem'
            />
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='1.5rem'
              width='1.5rem'
            />
          </div>

          {/* Main content placeholder */}
          <div className='Aag-TimelineLoader-main'>
            <div className='Aag-TimelineLoader-header'>
              <SkeletonLoader
                shape='square'
                animationStyle='wave'
                height='1.15rem'
                width='40%'
              />
              <SkeletonLoader
                shape='square'
                animationStyle='wave'
                height='1rem'
                width='4.5rem'
              />
            </div>
            <div className='Aag-TimelineLoader-attributes'>
              <SkeletonLoader
                shape='square'
                animationStyle='wave'
                height='1.75rem'
                width='100%'
              />
            </div>
          </div>

          {/* Timeline bar placeholder */}
          <div className='Aag-TimelineLoader-bar'>
            <div className='Aag-TimelineLoader-badge' />
            {lastIndex < rows.length - 1 && (
              <div className='Aag-TimelineLoader-line' />
            )}
          </div>

          {/* Timestamp placeholder */}
          <div className='Aag-TimelineLoader-timestamp'>
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='1rem'
              width='8.5rem'
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export const AuditLogTimelineLoader = memo(AuditLogTimelineLoaderComponent);
export const AuditLogTimelineLoaderSkeleton = AuditLogTimelineLoader;
